import { createStore } from "@tredespace/ui/lib";
import { BASE_DATUM_DEFAULT_MM } from "../../data/haki.ts";

export type DatumState = Readonly<{
  /**
   * Base-jack extension every standard on level ground is wound out to,
   * millimetres. Raising it lifts the whole 500 mm node grid with it.
   */
  baseDatumMm: number;
}>;

export const datumState = createStore<DatumState>({ baseDatumMm: BASE_DATUM_DEFAULT_MM });
